import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

import { ProjectClass } from '@/types/projectClass';

export type Props = {
  selected?: number | null;
  error?: string;
  selectedClass: ProjectClass;
  projectClasses: ProjectClass[];
  setSelectedClass: (selectedClass: ProjectClass) => void;
};

export const ProjectClasses: React.FC<Props> = ({
  selected,
  error,
  selectedClass,
  projectClasses,
  setSelectedClass,
}) => {
  const { t } = useTranslation();
  return (
    <Styled>
      <div className="l-block">
        <div id="projectClass" className={classnames('field', { error })}>
          <label>{t('models.subscription.projectClass')}</label>
          <Dropdown
            className="project-class-items"
            data-test="project-classes"
            options={projectClasses.map((projectClass, i) => ({
              active: selected ? selectedClass.id === projectClass.id : false,
              'data-test': `project-class-dropdown-${i}`,
              key: projectClass.id,
              onClick: () => setSelectedClass(projectClass),
              text: projectClass.name,
              value: projectClass.id,
            }))}
            selection={true}
            text={selectedClass.name}
            value={selectedClass.id}
          />
        </div>
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  .project-class-items {
    width: 66% !important;
  }
`;
